module.exports = __webpack_public_path__ + "static/media/16_lampa_31.93_2.31.5efb26a2.png";